export default __webpack_public_path__ + "static/axon-093b4fdf1c991cf1bdc59b12c98a38ad.svg";